import { atom, selector } from 'recoil';
import { getLanguages } from '../../api/languages';

const languagesSelector = selector({
    key: 'languagesSelector',
    get: async () => {
        const languages = await getLanguages();
        return languages.data
    },
});

export const selectedLanguageAtom = atom({
    key: 'selectedLanguageAtom',
    default: localStorage.getItem('language') || process.env.REACT_APP_DEFAULT_LANG,
});

export const languagesAtom = atom({
    key: 'languagesAtom',
    default: languagesSelector,
});
